import store from '../store'
// let permissions = store.state.permissions();
// let permit=updatePermissions(permissions);
function setPermissions(){
    let permissions = store.state.permissions();
    return updatePermissions(permissions);
}

function updatePermissions(permissions){
    return {
        '/':permissions && permissions.dashboard || true,
        '/companylist':permissions && permissions.company_list,
        '/announcements/create':permissions && permissions.announcement_create,
        '/setting/alladlogs':permissions && permissions.active_directory_view_logs,
        'adlogs':permissions && permissions.active_directory_view_logs,
        '/setting/listad':permissions && permissions.ad_servers,
        '/import/recipients':permissions && permissions.add_new_recepients,
        '/scenario/description':permissions && permissions.add_scenario,
        'scenario.edit.description':permissions && permissions.add_scenario,
        'scenario.edit.email':permissions && permissions.add_scenario,
        'scenario.edit.sms':permissions && permissions.add_scenario,
        'scenario.edit.team':permissions && permissions.add_scenario,
        'scenario.edit.whatsapp':permissions && permissions.add_scenario,
        'scenario.edit.landing':permissions && permissions.add_scenario,
        'scenario.edit.education':permissions && permissions.add_scenario,
        'scenario.edit.review':permissions && permissions.add_scenario,
        '/suppression':permissions && permissions.add_suppression,
        '/report/campaigns':permissions && permissions.all_reports,
        'report.comparereporting':permissions && permissions.all_reports,
        'report.recipientlisting':permissions && permissions.all_reports,
        // User Portal Traffic (Reports > Portal Logins). Gated on all_reports to match the
        // sidebar link in components/root/sidebar.vue — the two gates must agree, or the link
        // shows and beforeEach bounces the click to the dashboard.
        // Both keys because beforeEach checks path first, then name.
        '/reports/portal-logins':permissions && permissions.all_reports,
        'report.userportaltraffic':permissions && permissions.all_reports,
        '/reports/announcementcampaignsperformance':permissions && permissions.announcement_campaigns_new,
        '/reports/policyannouncementperformance':permissions && permissions.policy_announcement_new,
        '/report/allannouncements':permissions && permissions.announcement_reports,
        '/announcements':permissions && permissions.announcement_view,
        '/setting/trainingmail':permissions && permissions.auto_reminder_mail,
        '/managementreport/awarenesstrendslook':permissions && permissions.awareness_trend,
        '/managementreport/cybersecurityawarenesstrend':permissions && permissions.awareness_trend_new,
        '/setting/azure':permissions && permissions.azure_active_directory_authorization,
        '/campaigns/create':permissions && permissions.campaign_create,
        'campaigns.edit.description':permissions && permissions.campaign_create,
        'campaigns.edit.email':permissions && permissions.campaign_create,
        'campaigns.edit.sms':permissions && permissions.campaign_create,
        'campaigns.edit.team':permissions && permissions.campaign_create,
        'campaigns.edit.whatsapp':permissions && permissions.campaign_create,
        'campaigns.edit.landing':permissions && permissions.campaign_create,
        'campaigns.edit.education':permissions && permissions.campaign_create,
        'campaigns.edit.schedule':permissions && permissions.campaign_create,
        'campaigns.edit.review':permissions && permissions.campaign_create,
        '/report/allcampaigns':permissions && permissions.campaign_reports,
        '/bulk/campaigns':permissions && permissions.campaign_schedule,
        'bulk_campaigns.schedule':permissions && permissions.campaign_schedule,
        '/campaigns':permissions && permissions.campaign_view,
        'report.recipientlistinglogs':permissions && permissions.campaign_view,
        'preview':permissions && permissions.campaign_view,
        'report.campaignreporting':permissions && permissions.campaign_view,
        '/setting/oopspage':permissions && permissions.data_entry_oops_page,
        '/managementreport/departmentcompromise':permissions && permissions.department_compromise,
        '/newreports/VulnerabilityReport-DepartmentWiseUniqueEmployees':permissions && permissions.departments_new,
        '/vcro/all-departments-risk-score':permissions && permissions.departments_vcro,
        'vcro.department_risk_score':permissions && permissions.departments_vcro,
        '/managementreport/designationcompromise':permissions && permissions.designation_compromise,
        '/newreports/VulnerabilityReport-DesignationWiseUniqueEmployees':permissions && permissions.designations_new,
        '/reports/campaigns-detailed-report':permissions && permissions.detailed_new,
        '/report/detailed':permissions && permissions.detailed_report,
        '/company/domains':permissions && permissions.domains,
        '/setting/email':permissions && permissions.email_settings,
        '/setting/reply-to-credentials':permissions && permissions.email_settings,
        '/setting/directlearning':permissions && permissions.enrolments,
        'directlearning_recipient':permissions && permissions.enrolments,
        '/setting/general':permissions && permissions.general,
        '/vcro/all-groups-risk-score':permissions && permissions.groups_vcro,
        'vcro.group_risk_score':permissions && permissions.groups_vcro,
        '/managementreport/highrisk':permissions && permissions.high_risk_users,
        '/setting/HRIS-VSMS':permissions && permissions.hris_vsms_directory_service,
        '/setting/HRIS-VSMS-logs':permissions && permissions.hris_vsms_directory_service_logs,
        'HRISandVSMsingleLogs':permissions && permissions.hris_vsms_directory_service_logs,
        '/settings/ignore-list':permissions && permissions.ignore_ip_list,
        // '/settings/ignore-list/ignored-activities':permissions && permissions.ignore_ip_list,
        '/import_reporters':permissions && permissions.import_reporters,
        '/settings/import-trained-users':permissions && permissions.import_trained_users,
        '/settings/external-training-modules':permissions && permissions.import_trained_users,
        '/reports/laggards':permissions && permissions.laggardsnew,
        '/setting/master_landing':permissions && permissions.landing_page_templates,
        '/reports/leaderboard':permissions && permissions.leaderboard_new,
        '/setting/leaderboardsetting':permissions && permissions.leaderboard_settings,
        'lms':permissions && permissions.lms,
        '/recipients/manage-groups':permissions && permissions.manage_groups,
        '/settings/notifications':permissions && permissions.notifications,
        // Configuration alerts are about the admin's own settings, so anyone who
        // can reach the admin area can see them. Whether the page has anything
        // to show is decided server-side by the company's own on/off switch.
        // Both keys because beforeEach checks path first, then name.
        '/settings/system-alerts': true,
        'systemAlerts': true,
        '/vcro/organisation-risk-score':permissions && permissions.organisation_vcro,
        '/setting/books':permissions && permissions.passing_percentage,
        '/reports/phishingcampaignsperformance':permissions && permissions.phishing_campaigns_new,
        '/managementreport/reportingtrend':permissions && permissions.reporting_trend,
        '/managementreport/phishingreportingtrend':permissions && permissions.reporting_trend_new,
        '/setting/security':permissions && permissions.security,
        '/training_settings':permissions && permissions.settings,
        '/managementreport/strongest':permissions && permissions.strongest_links,
        '/managementreport/strongestlinks-least-compromised':permissions && permissions.strongest_links_least_compromised_new,
        '/managementreport/strongestlinks-most-reported':permissions && permissions.strongest_links_most_compromised_new,
        '/setting/throttling_sending_speed':permissions && permissions.throttling_speed,
        '/setting/training-languages': true,
        'training_languages': true,
        '/setting/dl_invitation_mail':permissions && permissions.training_invitation_mail,
        '/setting/dl_login_with_password_mail':permissions && permissions.training_login_template,
        '/bulkeducation':permissions && permissions.upload_modules,
        '/setting/usermanagement':permissions && permissions.user_management,
        '/vcro/all-users-risk-score':permissions && permissions.users_vcro,
        'vcro.user_risk_score':permissions && permissions.users_vcro,
        '/laggards':permissions && permissions.view_laggards,
        '/leaderboard':permissions && permissions.view_leaderboard,
        'trainingmoduleAdmin':permissions && permissions.is_education_editable,
        '/trainingmodule':permissions && permissions.view_modules,
        '/recipients':permissions && permissions.view_recepients,
        'recipients.group':permissions && permissions.view_recepients,
        'recipients.edit':permissions && permissions.view_recepients,
        '/scenario':permissions && permissions.view_scenario,
        '/imports/suppression':permissions && permissions.view_suppression,
        '/managementreport/phishingvulnerability':permissions && permissions.vulnerability_trend,
        '/managementreport/phishingvulnerabilitytrend':permissions && permissions.vulnerability_trend_new,
        '/managementreport/departmentweakest':permissions && permissions.weakest_departments,
        '/managementreport/weakestdepartments':permissions && permissions.weakest_departments_new,
        '/managementreport/weakest':permissions && permissions.weakest_links,
        '/managementreport/weakestlinks':permissions && permissions.weakest_links_new,
        '/setting/changepassword':permissions && permissions.change_password,
        'dashboard.weakestlinkuser':permissions && permissions.dashboard,
        '/report/hcsa_hisp':permissions && permissions.dashboard,
        '/reported/pluginusers':permissions && permissions.dashboard,
        '/gamification-engine/badges':permissions && permissions.gamification_badges,
        '/gamification-engine/add-badge':permissions && permissions.gamification_add_badgee,
        'gamification.edit_badge': permissions && permissions.gamification_add_badgee,
        'gamification-engine/award-log':permissions && permissions.gamification_award_log,
        '/gamification-engine/points':permissions && permissions.gamification_set_points,
        'gamification.award_log':permissions && permissions.gamification_award_log,
        'gamification.award_log_all':permissions && permissions.gamification_award_log,
        'userportal_new':permissions && permissions.dashboard || true,
        '/userportal/view-as':permissions && permissions.dashboard || true,
        '/userportal/customise':permissions && permissions.dashboard || true,
        '/gamification-engine/default-notification-email-settings':permissions && permissions.dashboard || true,
        'report.campaignfiledreports':true,
        'managementreport.repeatoffenders':true,
        '/userportal/news-updates':permissions && permissions.dashboard || true,
        '/userportal/customise-login-page':permissions && permissions.dashboard || true,
        '/logs/index':permissions && permissions.dashboard || true,
        '/exported-files':permissions && permissions.dashboard || true,
        '/settings/ignore-list/audit-log':true,
        '/settings/ignore-list/ignored-activities':true,
        '/settings/ignore-list/add-source':true,
        '/settings/ignore-list/suppression-logs':true,
        'report.view_log':true,
        '/teamportal':true,
        '/teamportal/customise':true,
        '/teamportal/view-as':true,
        '/announcementslive': true,
        '/userportal-v2/en':true,
        '/userportal-v2/ar': true,
        '/userportal-v2/customise':permissions && permissions.dashboard || true,
        '/userportal-v2/view-as':permissions && permissions.dashboard || true,
        '/userportal-v2/news-updates':permissions && permissions.dashboard || true,
        '/userportal-v2/customise-login-page':permissions && permissions.dashboard || true,
        '/setting/channel-credentials': true,
        '/schedule-calendar':true,
        '/policy/create': permissions && permissions.policy_create,
        '/policy': permissions && permissions.policy_view,
        '/setting/customize-admin-login': true,
        'notificationDescription':true,
        'O365Setup':true,
        '/create-needle-phishing':true,
        '/settings/ai-setting':true,
        '/add-agreement':true,
        '/agreement-details':true,
        '/adobe-auth':true,
        '/view-agreements':true,
        'agreement.details':true,
        '/settings/pdf-campaign':true,
        '/recipients/ou-settings':true,
        '/ip-information/campaign':true,
        '/ip-information/announcement':true,
        '/settings/campaign-user-role':true,
        '/creator-workspace':true,
        '/approver-workspace':true,
        '/campaigns/creator-workspace':true,
        '/campaigns/approver-workspace':true,
        '/announcements/creator-workspace':true,
        '/announcements/approver-workspace':true,
        '/policy/creator-workspace':true,
        '/policy/approver-workspace':true

    }
}

module.exports = {
    setPermissions,
}



// WEBPACK FOOTER //
// ./src/utils/permissions.js